import { useState, useMemo } from 'react'
import { Popup, SearchBar, CheckList } from 'antd-mobile'
import styles from './index.module.less'
import { ICountryNumber } from '@/pages/Login/types'

interface IProps {
  visible: boolean
  list: ICountryNumber[]
  onClose: () => void
  onChange: (data: ICountryNumber) => void
}

/**
 * 选择国家和区号
 * @param props 
 * @returns 
 */
function ZoneNumberList(props: IProps) {
  const { visible, list, onClose, onChange } = props
  const [searchText, setSearchText] = useState('')
  const [selected, setSelected] = useState('')
  const filteredList: ICountryNumber[] = useMemo(() => {
    if (!searchText) return list
    const listByCountry = list.filter(item => item.countryName.includes(searchText))
    const listByCode = list.filter(item => item.telephoneCode.includes(searchText))
    if (listByCountry && listByCountry.length) return listByCountry
    if (listByCode && listByCode.length) return listByCode
    return []
  }, [list, searchText])

  function onCheckChange(val: string[] = []) {
    const countryId = val[0]
    const zoneNumberData = list.find(item => item.countryId === countryId)
    if (!countryId || !zoneNumberData) return
    setSelected(countryId)
    onChange(zoneNumberData)
  }

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      destroyOnClose
    >
      <div className={styles.searchBarContainer}>
        <SearchBar
          placeholder='搜索国家'
          value={searchText}
          onChange={setSearchText}
        />
      </div>
      <div className={styles.checkListContainer}>
        <CheckList
          className={styles.myCheckList}
          multiple={ false }
          defaultValue={selected ? [selected] : []}
          onChange={onCheckChange}
        >
          {filteredList.map(item => (
            <CheckList.Item key={item.countryId} value={item.countryId}>
              {`${item.telephoneCode} (${item.countryName})`}
            </CheckList.Item>
          ))}
        </CheckList>
      </div>
    </Popup>
  )
}

export default ZoneNumberList